
<lib-icon-set></lib-icon-set>

<lib-carousel class="carousel" [media]="media$" ></lib-carousel>

<div 
	class="content"
	libSwipeNavigate
  	[@routeAnimation]="routeAnimationParams$ | push: 'immediate'"
  	(@routeAnimation.done)="onRouteAnimDone()"
	>
	<router-outlet></router-outlet>
</div>

<lib-top-bar class="top-bar">
	<a 
	[routerLink]="['/uvod']"
	routerLinkActive="active"
	title="Úvod"
	matRipple
	>
		<lib-icon class="logo" name="logo" ></lib-icon>
	</a>
	<lib-menu class="menu" [routes]="routes$" [routeChanged]="routeChanged$"></lib-menu>
	<lib-mobile-menu 
		class="mobile-menu" 
		[routes]="routes$"
		[@menuSlide]="menuOpen() ? 'open' : 'closed'"
	></lib-mobile-menu>
	<lib-toggle-icon 
		class="search" 
		(click)="toggleSearch()"
		iconInActive="search" 
		iconActive="close" 
		[state]="searchOpen" 
	></lib-toggle-icon>
	<lib-toggle-icon 
		class="burger" 
		(click)="toggleMenu()"
		iconInActive="menu" 
		iconActive="close" 
		[state]="menuOpen" 
	></lib-toggle-icon>
</lib-top-bar>

<lib-fulltext-search
    [routesMap]="pages$"
    [resetOn]="currentRoute$"
    [minChars]="3"
    [@submenuState]="searchOpen() ? 'open' : 'closed'" 
    (@submenuState.done)="onSearchAnimationDone()"
  />

<lib-arrows [navigation]="navigation$" [libKeyboardRouteNavigation]="navigation$" ></lib-arrows>



